import { OptionType } from 'apps/web/enums/iPlanObjectives/categories.enum';
import {
  BehavioralVerb,
  Domain,
  Category,
} from 'apps/web/types/labelled-collection.type';

import { getAffectiveVerbs } from '../affective';
import { getCognitiveVerbs } from '../cognitive';
import { getPsychomotorVerbs } from '../psychomotor';

import {
  createCognitiveCategories,
  createAffectiveCategories,
  createPsychomotorCategories,
} from './categoryFactory';

export const assignVerbsToCategories = (
  categories: Category[],
  verbSets: Record<number, BehavioralVerb[]>,
) => {
  Object.entries(verbSets).forEach(([indexStr, verbs]) => {
    const index = parseInt(indexStr);
    if (index < categories.length) {
      categories[index].items = verbs;
    }
  });
  return categories;
};

export enum DomainName {
  Cognitive = 'Cognitive',
  Affective = 'Affective',
  Psychomotor = 'Psychomotor',
}

const createDomainWithVerbs = (
  type: OptionType,
  domainName: DomainName,
  createCategories: () => Category[],
  getVerbs: (isDigital: boolean) => Record<number, BehavioralVerb[]>,
): Domain[] => {
  const isDigital = type === OptionType.Digital;
  const categories = createCategories();
  assignVerbsToCategories(categories, getVerbs(isDigital));
  return [{ label: domainName, items: categories }];
};

export const createCognitiveDomain = (type: OptionType): Domain[] => {
  return createDomainWithVerbs(
    type,
    DomainName.Cognitive,
    createCognitiveCategories,
    getCognitiveVerbs,
  );
};

export const createAffectiveDomain = (type: OptionType): Domain[] => {
  return createDomainWithVerbs(
    type,
    DomainName.Affective,
    createAffectiveCategories,
    getAffectiveVerbs,
  );
};

export const createPsychomotorDomain = (type: OptionType): Domain[] => {
  return createDomainWithVerbs(
    type,
    DomainName.Psychomotor,
    createPsychomotorCategories,
    getPsychomotorVerbs,
  );
};
